import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from '../color';
import { FONT_FAMILY_SCHEMA } from '../fonts';
import { PADDING_SCHEMA } from '../padding';
export const RichTextPropsSchema = z.object({
    style: z
        .object({
        color: COLOR_SCHEMA,
        backgroundColor: COLOR_SCHEMA,
        fontSize: z.number().nullable().optional(),
        fontFamily: FONT_FAMILY_SCHEMA,
        fontWeight: z.enum(['bold', 'normal']).nullable().optional(),
        textAlign: z.enum(['left', 'center', 'right']).nullable().optional(),
        padding: PADDING_SCHEMA,
    })
        .nullable()
        .optional(),
    props: z
        .object({
        markdown: z.boolean().nullable().optional(),
        text: z.string().nullable().optional(),
    })
        .nullable()
        .optional(),
});
export function RichText({ style, props }) {
    const htmlContent = props === null || props === void 0 ? void 0 : props.text;
    // Convert padding object to valid CSS string
    const padding = (style === null || style === void 0 ? void 0 : style.padding)
        ? `${style.padding.top}px ${style.padding.right}px ${style.padding.bottom}px ${style.padding.left}px`
        : undefined;
    return (React.createElement("div", { "data-custom": "1", style: Object.assign(Object.assign({}, style), { padding }), dangerouslySetInnerHTML: { __html: htmlContent } }));
}
//# sourceMappingURL=RichText.js.map